
$(document).ready(function () {
    $(".header__img").on("click", function () {
      $("nav").slideToggle();
    });
  });